import { h, Component } from 'preact';
import { Link } from 'preact-router/match';
import Box from '../box/Box';
import Heading from '../typography/heading/Heading';
import Text from '../typography/text/Text';
import Wechat from '../../assets/images/Wechat1.svg';
import style from './style';
import Weibo from '../../assets/images/Weibo.svg';
import Zhihu from '../../assets/images/Zhihu.svg';
import QRCode from '../../assets/images/QR_code.jpg';

export default class Footer extends Component {
	render() {
		const iconStyles = {width: '67px', height: '67px', borderRadius: '50%', color: 'white'};
		const imgStyles = {width: '200px', height: '200px', marginLeft: '7px'};
		const linkStyles = {minWidth: '90px', textDecoration: 'none', paddingBottom: '5px', marginRight: '5px'};
		return (
			<footer class={style.footer}>
				<div class={style.text} style='margin-right: 8%'>
					<Box marginBottom='20px'>
                        <Heading size='lg' accessibilityLevel={3} color='white'>
                            其他内容
                        </Heading>
					</Box>
					<Box direction='column'>
						<a href='#' style={linkStyles}>
                            <Text color='white' fontWeight='bold'>罗博深首页</Text>
						</a>
                        <a href='/about' style={linkStyles}>
                            <Text color='white' fontWeight='bold'>谁是罗博深</Text>
                        </a>
                        <a href='/#activities' style={linkStyles}>
                            <Text color='white' fontWeight='bold'>罗博深在中国</Text>
                        </a>
                        <a href='http://join-tsinghua.edu.cn/publish/bzw/7545/2018/20180615162335858871445/20180615162335858871445_.html' style={linkStyles} target='_blank'>
                            <Text color='white'>训练营课程</Text>
                        </a>
                        <a href='/courses' style={linkStyles}>
                            <Text color='white'>视频课程</Text>
                        </a>
					</Box>
				</div>

                <div class={style.displayLine}>
                    <span style="padding-left: 150px; padding-right: 110px; line-weight: 5px">&nbsp;</span>
                </div>

				<div class={style.text}>
                    <Box marginBottom='20px' justify='flex-start'>
                        <Heading size='lg' accessibilityLevel={3} color='white'>
                            联系我们
                        </Heading>
                    </Box>
					<Box direction='column'>
                        <div style={linkStyles}>
                            <Text color='white'>商务合作邮箱：partnership@expii.com</Text>
                        </div>
                        <div style={linkStyles}>
                            <Text color='white'>课程咨询问题：boshuzhushou1(微信号)</Text>
                        </div>
					</Box>
				</div>

                <div class={style.displayLine}>
                    <span style="padding-left: 150px; padding-right: 110px; line-weight: 5px">&nbsp;</span>
                </div>

          		<div class={style.text}>
					<div class={style.thirdColumn}>
                        <Box marginBottom='20px'>
                            <Heading size='lg' accessibilityLevel={3} color='white'>
                                关注我们
                            </Heading>
                        </Box>
					</div>
						<Box>
							<div class={style.rightMostIcons}>
                                <a href="https://image.ibb.co/f5qBry/QR_code.jpg" style={linkStyles} class={style.tooltip}>
                                    <span class={style.tooltiptext}>
                                        <img src={QRCode} class={style.QRcodeImage}/>
                                        <Text color='black' textAlign='center'>扫码关注</Text>
                                    </span>
                                    <div class={style.thirdColumn}>
                                        <Box direction='column' align='center'>
                                            <img src={Wechat} style={iconStyles}/>
                                            <Text color='lightgray'>微信公众号</Text>
                                        </Box>
                                    </div>
                                </a>
                                <a href="https://www.weibo.com/poshenloh" style={linkStyles} target="_blank">
                                    <div class={style.thirdColumn}>
                                        <Box direction='column' align='center'>
                                            <img src={Weibo} style={iconStyles}/>
                                            <Text color='lightgray'>新浪微博</Text>
                                        </Box>
                                    </div>
                                </a>
                                <a href="https://www.zhihu.com/people/po-shen-loh/activities" style={linkStyles} target="_blank">
                                    <div class={style.thirdColumn}>
                                        <Box direction='column' align='center'>
                                            <img src={Zhihu} style={iconStyles}/>
                                            <Text color='lightgray'>知乎</Text>
                                        </Box>
                                    </div>
                                </a>
							</div>
						</Box>
         			</div>
					<Box>
         		 </Box>
			</footer>
		);
	}
}



// WEBPACK FOOTER //
// ./components/footer/index.js